class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    //this.setupHoverPreview();
  }

  setupHoverPreview() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const hideDelay = 2000;
    let hideTimeout = null;

    const show = () => {
      clearTimeout(hideTimeout);
      this.classList.add('is-hover-open');
    };
    // Espera ~2s antes de ocultar para dar margen a mover el cursor del icono al panel.
    const scheduleHide = () => {
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => this.classList.remove('is-hover-open'), hideDelay);
    };

    [cartIcon, this].forEach((element) => {
      element.addEventListener('mouseenter', show);
      element.addEventListener('mouseleave', scheduleHide);
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.notification.classList.remove('is-empty');
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!target || !html) return;
      try {
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      } catch (e) {
        console.warn(`cart-notification: failed to render section "${section.id}"`, e);
      }
    });

    this.updateTitle();

    if (this.header) this.header.reveal();
    this.open();
  }

  updateTitle() {
    const labelEl = document.querySelector('.cart-notification__heading-label');
    if (!labelEl) return;
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const count = cart.item_count;
        const label = count === 1 ? 'Producto' : 'Productos';
        labelEl.textContent = `(${count} ${label})`;
      })
      .catch(() => {});
  }

  getSectionsToRender() {
    const showAllItems = this.dataset.showAllItems === 'false';
    return [
      {
        id: 'cart-notification-product',
        selector: showAllItems ? '.shopify-section' : `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-notification-subtotal',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
